import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { getHideToggleMenuItem } from "../../../common_nextgen/common_components/MenuItemButton/MenuItemButton";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useAdditionalPatientPay = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  setFalg,
  selectParamsData,
  setScheduleDesc,
  onNavigate
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");

  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };
  const closeHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const [hideFlag, setHideFlag] = useState(false);
  const toast = useToast();
  const location = useLocation();

  const {
    ADDITIONAL_PATIENT_PAY_SCHEDULE_ADD,
    ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY,
    ADDITIONAL_PATIENT_PAY_SCHEDULE_EDIT,
    COPY_PRICE_SCHEDULE,
    ADDITIONAL_PATIENT_PAY_NOTE,
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
    ADDITIONAL_PATIENT_PAY_STEPS,
  } = ROUTE_PATHS;

  const screen_title = "Additional Patient Pay Schedule";
  /* cspell:disable-next-line */
  const screenNumber = selectMode ? "RCAPS004" : "RCAPS001";

  const stateVal = Array.isArray(location?.state) ? location.state : [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      apsAddtlPatPaySch: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;

  const baseParamsData = lookupType
    ? { ...selectParamsData, hiddenRecordIndicator: "Active" }
    : initialParamsData;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [paramsData, setParamsData] = useState(baseParamsData);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.apsAddtlPatPaySch;
  const updatedParamsData = {
    ...paramsData,
    apsAddtlPatPaySch: lastScheduleName,
  };

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "APS Addtl Pat Pay Sch",
      name: "apsAddtlPatPaySch",
      label: "Schedule",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    hideModal();
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add Additional Patient Pay Schedule",
          button_handeler: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_SCHEDULE_ADD, [
              {
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            /* const message = {
              message: "navigate-to-presto",
              programCode: "RCAPN001",
              parameters: {
                apsAddtlPatPaySch: rowData["apsAddtlPatPaySch"],
                apsAddtlPatpaySchDesc: rowData["apsAddtlPatpaySchDesc"],
                workInitialProgramMode: "CHG",
              },
            };
            console.log(message, "message");
            window.parent.postMessage(message, "*");*/
            onNavigate({
              data: rowData,
              target: ROUTE_PATHS.ADDITIONAL_PATIENT_PAY_NOTE,
              navType: "local",
              schedulesDataKey: "selectedAdditionalPatients",
            });
          },
        },
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramData = selectParams.reduce((acc, key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                acc[key["source"]] = rowData[key["target"]];
              }
              return acc;
            }, {});
            if (lookupType !== "external") {
              const { apsAddtlPatPaySch, apsAddtlPatpaySchDesc } = rowData;
              onSelect({
                apsAddtlPatPaySch: apsAddtlPatPaySch,
                apsAddtlPatpaySchDesc: apsAddtlPatpaySchDesc,
              });
              setFalg(true);
            } else {
              window.parent.postMessage(paramData);
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            /*const message = {
              message: "navigate-to-presto",
              programCode: "RCAPS003",
              parameters: {
                apsAddtlPatPaySch: rowData["apsAddtlPatPaySch"],
                workInitialProgramMode: "DSP",
              },
            };
            console.log(message, "message");
            window.parent.postMessage(message, "*");
            */

            onNavigate({
              data: rowData,
              target: ROUTE_PATHS.ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY,
              navType: "local",
              schedulesDataKey: "selectedAdditionalPatients",
            });
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            /*const message = {
              message: "navigate-to-presto",
              programCode: "RCAPT002I",
              parameters: {
                apsAddtlPatPaySch: rowData["apsAddtlPatPaySch"],
                apsAddtlPatpaySchDesc: rowData["apsAddtlPatpaySchDesc"],
              },
            };
            console.log(message, "message");
            window.parent.postMessage(message, "*");*/
            onNavigate({
              data: rowData,
              target: ROUTE_PATHS.ADDITIONAL_PATIENT_PAY_STEPS,
              navType: "local",
              schedulesDataKey: "selectedSchedules",
            });
          },
        },
      ]
    : [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_NOTE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedAdditionalPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_SCHEDULE_EDIT, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedAdditionalPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedAdditionalPatients: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_STEPS, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        getHideToggleMenuItem(
          rowData.hiddenRecordIndicator,
          openHideConfirmationModal
        ),
      ].filter((menuItem) => menuItem !== undefined);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "apsAddtlPatPaySch",
    },
    {
      header: "Description",
      field: "apsAddtlPatpaySchDesc",
    },
    {
      header: "Steps",
      field: "workNumber2",
    },
    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell rowData={rowData} fields={["noteExistenceStatus"]} tooltipContent={{noteExistenceStatus: "Notes"}} />
      ),
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "apsAddtlPatPaySch";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/apsAdlPatPaySched`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const hideAdditionalPatientPay = () => {
    if (hideSelectedOption === "yes") {
      let apsAddtlPatPaySchList = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        apsAddtlPatPaySchList = selectedRows.map(
          (row) => row.apsAddtlPatPaySch
        );
      } else if (rowData && Object.keys(rowData).length > 0) {
        apsAddtlPatPaySchList[0] = rowData.apsAddtlPatPaySch;
      }
      if (apsAddtlPatPaySchList.length > 0) {
        const params = {
          screenNumber: screenNumber,
        };
        axios_helper_no_header(
          "PUT",
          "api/apsAdlPatPaySched/hideUnhide",
          apsAddtlPatPaySchList,
          params
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            setHideFlag(!hideFlag);
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeHideConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error hiding the data!", error);
            toast.current.show({
              severity: "error",
              summary: "",
              detail: error.message,
              life: 3000,
            });
            closeHideConfirmationModal();
          });
      } else {
        closeHideConfirmationModal();
      }
    } else {
      closeHideConfirmationModal();
    }
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      let apsAddtlPatPaySchList = [];
      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        apsAddtlPatPaySchList = selectedRows.map(
          (row) => row.apsAddtlPatPaySch
        );
      } else if (rowData && Object.keys(rowData).length > 0) {
        apsAddtlPatPaySchList[0] = rowData.apsAddtlPatPaySch;
      }
      if (apsAddtlPatPaySchList.length > 0) {
        // const params = { apsAddtlPatPaySch: rowData[parmKey] };
        axios_helper_no_header(
          "DELETE",
          "api/apsAdlPatPaySched",
          apsAddtlPatPaySchList,
          null
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            // fetchData();
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
          })
          .catch((error) => {
            console.error("There was an error deleting the data!", error);
            const {
              responseStatus: { displayErrorFields = null, message } = {},
            } = error.data;
            toast.current.show({
              severity: "error",
              summary: "",
              detail: message,
              life: 3000,
            });
            closeConfirmationModal();
          });
      } else {
        closeConfirmationModal();
      }
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/apsAdlPatPaySched/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    leftButtons,
    selectMode,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    isHideConfirmationModalOpen,
    closeConfirmationModal,
    closeHideConfirmationModal,
    deletePriceSchedule,
    hideAdditionalPatientPay,
    setSelectedOption,
    setHideSelectedOption,
  };
};

export default useAdditionalPatientPay;
